import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  ProductCategoryRequest,
  ProductCategoryResponse,
  ProductCategorySearchParams
} from '../models/categoria-producto.model';

@Injectable({
  providedIn: 'root'
})
export class CategoriaProductoApiService {
  private readonly apiUrl = `${environment.apiUrl}api/product-categories`;

  constructor(private http: HttpClient) { }

  searchProductCategory(params: ProductCategorySearchParams): Observable<ProductCategoryResponse[]> {
    let httpParams = new HttpParams()
      .set('businessId', params.businessId.toString())
      .set('activeOnly', (params.activeOnly ?? true).toString());

    if (params.idParent !== undefined) {
      httpParams = httpParams.set('idParent', params.idParent.toString());
    }
    if (params.searchName) {
      httpParams = httpParams.set('searchName', params.searchName);
    }
    if (params.type) {
      httpParams = httpParams.set('type', params.type);
    }

    return this.http.get<ProductCategoryResponse[]>(this.apiUrl, { params: httpParams });
  }

  getProductCategoryById(id: number): Observable<ProductCategoryResponse> {
    return this.http.get<ProductCategoryResponse>(`${this.apiUrl}/${id}`);
  }

  createProductCategory(category: ProductCategoryRequest): Observable<ProductCategoryResponse> {
    return this.http.post<ProductCategoryResponse>(this.apiUrl, category);
  }

  updateProductCategory(id: number, category: ProductCategoryRequest): Observable<ProductCategoryResponse> {
    return this.http.put<ProductCategoryResponse>(`${this.apiUrl}/${id}`, category);
  }

  deleteProductCategory(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  getRootProductCategories(businessId: number): Observable<ProductCategoryResponse[]> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<ProductCategoryResponse[]>(`${this.apiUrl}/root`, { params });
  }

  getChildProductCategories(parentId: number, businessId: number): Observable<ProductCategoryResponse[]> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<ProductCategoryResponse[]>(`${this.apiUrl}/${parentId}/children`, { params });
  }
}
